import React, { useEffect } from 'react';
import confetti from 'canvas-confetti';
import { motion, AnimatePresence } from 'framer-motion';

interface PointsFeedbackProps {
  show: boolean;
  points: number;
  onComplete: () => void;
}

const PointsFeedback: React.FC<PointsFeedbackProps> = ({ show, points, onComplete }) => {
  useEffect(() => {
    if (show) {
      // Trigger fireworks
      const duration = 1200;
      const animationEnd = Date.now() + duration;
      const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

      const randomInRange = (min: number, max: number) => {
        return Math.random() * (max - min) + min;
      };

      const interval: any = setInterval(function() {
        const timeLeft = animationEnd - Date.now();

        if (timeLeft <= 0) {
          return clearInterval(interval);
        }

        const particleCount = 50 * (timeLeft / duration);
        // since particles fall down, start a bit higher than random
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 }
        });
        confetti({
            ...defaults,
            particleCount,
            origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 }
        });
      }, 250);

      // Hide after animation
      const timer = setTimeout(() => {
        onComplete();
      }, 1200);

      return () => {
        clearInterval(interval);
        clearTimeout(timer);
      };
    }
  }, [show, onComplete]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.5, x: 100 }}
          animate={{ opacity: 1, scale: 1, x: 0 }}
          exit={{ opacity: 0, scale: 0.8, x: 100 }}
          transition={{ type: "spring", stiffness: 400, damping: 25 }}
          className="fixed top-20 right-6 pointer-events-none z-50"
        >
          <div className="bg-white/95 backdrop-blur-sm px-6 py-4 rounded-2xl shadow-2xl flex flex-col items-center border-2 border-yellow-400">
            <span className="text-4xl mb-1">🎉</span>
            <h2 className="text-2xl font-black text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-orange-500 filter drop-shadow-sm">
              +{points} Points!
            </h2>
            <p className="text-gray-600 font-semibold text-sm mt-1">Excellent work!</p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PointsFeedback;
